import React, { useEffect, useState } from "react";
import moment from "moment";
import useBookings from "hooks/useBookings";
import Cost from "./components/Cost";
import useSelection from "hooks/useSelection";
import SelectedOption from "./components/SelectedOption";
import useAPI from "hooks/useAPI";
import { useCorporateMode } from "context/CorporateModeContext";
import { BsXLg, BsHourglass } from "react-icons/bs";

const BookingSummary = ({ booking, selection }) => {
  const { isCorporate } = useCorporateMode();
  const [discountCode, setDiscountCode] = useState(null);
  const [appliedDiscountCode, setAppliedDiscountCode] = useState(null);
  const { bookingHasBeenPaid } = useBookings();
  const { API } = useAPI({});

  const { setSelectionForKey } = useSelection({
    key: "discountCode",
    setter: (value) => {
      if (!appliedDiscountCode) {
        setAppliedDiscountCode(value);
      }
      setDiscountCode(value);
    },
  });

  const handleChangeDiscountCode = (e) => {
    setDiscountCode(e.target.value && e.target.value.trim());
  };

  const clearDiscount = () => {
    setAppliedDiscountCode(null);
    setDiscountCode(null);
    setSelectionForKey(null);
  };

  useEffect(() => {
    checkAndSetAppliedDiscountCode();

    // setSelectionForKey(appliedDiscountCode);
  }, [appliedDiscountCode]);

  const checkAndSetAppliedDiscountCode = async () => {
    if (bookingHasBeenPaid(booking)) return;
    if (!appliedDiscountCode) {
      setSelectionForKey(appliedDiscountCode);
    } else {
      let data = await API.get(
        `/discount-codes/${appliedDiscountCode}/is-valid`,
      );
      if (data?.isValid) {
        setSelectionForKey(appliedDiscountCode);
      } else {
        alert("Sorry that code is not valid, please check and try again.");
        setAppliedDiscountCode(null);
      }
    }
  };

  const TextUtil = ({ text, camelToNormal }) => {
    if (camelToNormal) {
      return text.replace(/([a-z])([A-Z])/g, "$1 $2");
    } else {
      return text;
    }
  };

  return (
    <div className="flex flex-col w-full h-full z-10 md:mt-4 p-4">
      <div className="flex-grow flex items-center">
        <div className="container mx-auto">
          {/* <Selection obj={selection} /> */}

          <div
            className="relative w-full md:w-7/12 mx-auto md:p-20"
            style={
              {
                // backgroundImage: "url(/images/bubble-bgs/sky-blue.jpg)",
                // backgroundPosition: "center",
                // backgroundSize: "cover",
                // borderRadius: "200px",
              }
            }
          >
            <div className="w-full h-full absolute top-0 left-0 hidden md:block z-5 ">
              <img
                src="/images/bubble-bgs/sky-blue.jpg"
                className="w-full h-full rounded-[200px]"
              />
            </div>
            <div className="z-10 relative">
              <SelectedOption
                title="Where"
                linkTo="/where"
                iconImgSrc={"/images/confirm/icons/where.png"}
              >
                london&nbsp;(
                <span className=" mirum-comma-delimit-items">
                  {Object.keys(selection.where).map((location) => {
                    return selection.where[location] === true ? (
                      <span className="mr-1 ">
                        {location.replace("-", " ")}
                      </span>
                    ) : null;
                  })}
                </span>
                )
              </SelectedOption>

              <SelectedOption
                title="when"
                linkTo="/when"
                iconImgSrc={"/images/confirm/icons/when.png"}
              >
                {moment(selection.when.date).format("DD/MM/YYYY")},{" "}
                {selection.when.startTime} - {selection.when.endTime}
              </SelectedOption>

              <SelectedOption
                title="What"
                linkTo="/what"
                iconImgSrc={"/images/confirm/icons/what.png"}
              >
                <div>
                  {selection.what.map((item) => {
                    if (item.selections.length === 0) return null;
                    return (
                      <div className="block mb-2">
                        <span className="inline-block mr-1 lowercase">
                          {
                            <TextUtil
                              text={item.activity}
                              camelToNormal={true}
                            />
                          }
                        </span>
                        <small>(</small>
                        <div className="inline mirum-comma-delimit-items">
                          {item?.selections?.map((selected) => {
                            return (
                              <span>
                                <small>{selected}</small>
                              </span>
                            );
                          })}
                        </div>
                        <small>)</small>
                        <span>
                          {item.additionalQuestions &&
                            Object.keys(item.additionalQuestions).map((key) => {
                              return (
                                <div className="inline ml-2">
                                  <span className="lowercase">
                                    <TextUtil text={key} camelToNormal={true} />
                                    :
                                  </span>
                                  <span className="ml-2">
                                    {item.additionalQuestions[key]
                                      ?.additionalNotes ||
                                      item.additionalQuestions[key]?.answer}
                                  </span>
                                </div>
                              );
                            })}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </SelectedOption>

              <SelectedOption
                title="Number of People"
                linkTo="/anything"
                iconImgSrc={"/images/confirm/icons/party.png"}
              >
                {selection.anything?.noOfPeople || "N/A"}
              </SelectedOption>

              <SelectedOption
                title="Vibe"
                linkTo="/anything"
                iconImgSrc={"/images/confirm/icons/vibe.png"}
              >
                <div className="mirum-comma-delimit-items">
                  {selection.anything?.vibe.map((item) => {
                    return (
                      <span className="mr-1">{item.replace("-", " ")}</span>
                    );
                  })}
                </div>
              </SelectedOption>
              <SelectedOption
                title="Accessibility"
                linkTo="/anything"
                iconImgSrc={"/images/confirm/icons/accessibility.png"}
              >
                {selection.anything?.accessibility.map((item) => {
                  return <span className="mr-1">{item}</span>;
                })}
              </SelectedOption>
              <SelectedOption
                title="Are you from London?"
                linkTo="/anything"
                iconImgSrc={"/images/confirm/icons/london.png"}
              >
                {selection.anything?.fromLondon.map((item) => {
                  return <span className="mr-1">{item}</span>;
                })}
              </SelectedOption>
              <SelectedOption
                title="Early reveal?"
                linkTo="/anything"
                icon={<BsHourglass />}
              >
                {selection.anything?.earlyReveal?.[0]
                  ? selection.anything.earlyReveal[0].charAt(0).toUpperCase() +
                    selection.anything.earlyReveal[0].slice(1)
                  : "N/A"}
              </SelectedOption>
              <SelectedOption
                title="Budget"
                linkTo="/budget"
                iconImgSrc={"/images/confirm/icons/budget.png"}
              >
                £{selection.budget}&nbsp;per person
              </SelectedOption>
              <SelectedOption title="Notes" linkTo="/anything">
                {selection.anything.notes?.length > 0
                  ? selection.anything?.notes
                  : "N/A"}
              </SelectedOption>
              {isCorporate && (
                <SelectedOption title="Type">
                  this a mirum for corporations
                </SelectedOption>
              )}

              {!booking ||
                (booking.status === "draft" &&
                  !bookingHasBeenPaid(booking) &&
                  !isCorporate && (
                    // DISCOUNT CODE (consumer only)

                    <SelectedOption
                      title="Discount Code"
                      style={{ display: "block" }}
                      childDivClassName="block w-full"
                    >
                      <div className="block w-full">
                        {!appliedDiscountCode && (
                          <div className="flex w-full">
                            <input
                              type="text"
                              className="mirum-text-field grow !rounded-bl-3xl !rounded-tl-3xl grow"
                              placeholder="enter your code"
                              value={discountCode ? discountCode : ""}
                              onChange={handleChangeDiscountCode}
                            />
                            <input
                              disabled={
                                !discountCode || discountCode.length < 3
                              }
                              type="submit"
                              value="apply"
                              className="bg-[var(--peachy-pink)] text-white px-4 rounded-tr-3xl rounded-br-3xl"
                              onClick={() => {
                                setAppliedDiscountCode(discountCode);
                              }}
                            />
                          </div>
                        )}
                        {/* )} */}
                        {appliedDiscountCode && (
                          <div className="flex items-center gap-2">
                            {discountCode}{" "}
                            <div
                              onClick={clearDiscount}
                              className="cursor-pointer"
                            >
                              <BsXLg style={{ fontSize: "14px" }} />
                            </div>
                          </div>
                        )}
                      </div>
                    </SelectedOption>
                  ))}
              {bookingHasBeenPaid(booking) && (
                <SelectedOption title="Payment">
                  <p className="lowercase">
                    Paid on{" "}
                    {moment
                      .unix(booking.stripe.paymentIntent.created)
                      .format("DD/MM/YYYY HH:MM")}
                  </p>
                </SelectedOption>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSummary;
